// A fancyful colors demo page; props and credits to,
// https://roobinium.io/, for a beatiful and easy to use design.

import { DemoHeader, DemoInfoBox } from '@/components/demo';
import { PrimaryButton, OutlineButton } from '@/components/buttons';

export const ButtonsDemo = () => {
    return (
        <div className="min-h-screen p-12">
            <div className="max-w-6xl mx-auto space-y-16">
                <DemoHeader badge="#assets" title="buttons" />

                <DemoInfoBox 
                    description={
                        <>
                            Buttons are accessed as <span className="text-primary font-bold">React components</span>. 
                            Import and use them with <code className="px-2 py-1 bg-base-300 rounded text-sm">onClick</code> handlers and <code className="px-2 py-1 bg-base-300 rounded text-sm">children</code> props.
                        </>
                    }
                    example="<PrimaryButton onClick={handleClick}>Click Me</PrimaryButton>"
                />

                {/* Filled Buttons Section */}
                <div className="space-y-5">
                    <div className="relative pb-5 border-b border-gray-400/60">
                        <h3 className="font-montserrat text-base font-bold">filled</h3>
                        <p className="absolute right-0 top-7 text-sm font-montserrat font-medium">4 styles</p>
                    </div>

                    {/* Primary Button - Large */}
                    <div className="space-y-4">
                        <div className="grid grid-cols-2 gap-12">
                            <div>
                                <p className="text-white text-sm font-medium font-montserrat leading-5 mb-4">default</p>
                                <PrimaryButton className="w-96">Join the ICO</PrimaryButton>
                            </div>
                            <div>
                                <p className="text-white text-sm font-medium font-montserrat leading-5 mb-4">hover</p>
                                <div className="w-96 px-2.5 py-4 bg-[#A1FF87] rounded-2xl flex justify-center items-center">
                                    <span className="text-primary-content text-base font-medium font-outfit leading-6">Join the ICO</span>
                                </div>
                            </div>
                        </div>
                        <p className="text-xs font-outfit text-white/60 mt-2">
                            Component: <code className="px-2 py-1 bg-base-300 rounded text-xs">PrimaryButton</code> (large)
                        </p>
                    </div>

                    {/* Outline Button with Hover Fill */}
                    <div className="space-y-4 mt-12">
                        <div className="grid grid-cols-2 gap-12">
                            <div>
                                <p className="text-white text-sm font-medium font-montserrat leading-5 mb-4">default</p>
                                <OutlineButton className="w-48">Whitepaper</OutlineButton>
                            </div>
                            <div>
                                <p className="text-white text-sm font-medium font-montserrat leading-5 mb-4">hover</p>
                                <div className="w-48 px-2.5 py-4 bg-primary rounded-2xl outline outline-1 outline-offset-[-1px] outline-primary flex justify-center items-center">
                                    <span className="text-primary-content text-base font-medium font-outfit leading-6">Whitepaper</span>
                                </div>
                            </div>
                        </div>
                        <p className="text-xs font-outfit text-white/60 mt-2">
                            Component: <code className="px-2 py-1 bg-base-300 rounded text-xs">OutlineButton</code>
                        </p>
                    </div>
                </div>

                {/* Usage Examples */}
                <div className="bg-base-200 rounded-[20px] p-6 border border-base-300">
                    <h4 className="font-montserrat text-base font-bold mb-4">Usage Examples</h4>
                    <div className="space-y-3 font-mono text-sm">
                        <div className="bg-base-300 rounded p-3">
                            <code className="text-white/80">{`<PrimaryButton onClick={() => console.log('clicked')}>Join the ICO</PrimaryButton>`}</code>
                        </div>
                        <div className="bg-base-300 rounded p-3">
                            <code className="text-white/80">{`<PrimaryButton className="w-full">Get Started</PrimaryButton>`}</code>
                        </div>
                        <div className="bg-base-300 rounded p-3">
                            <code className="text-white/80">{`<OutlineButton>Whitepaper</OutlineButton>`}</code>
                        </div>
                        <div className="bg-base-300 rounded p-3">
                            <code className="text-white/80">{`<OutlineButton disabled={isLoading}>Learn More</OutlineButton>`}</code>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};